<template>
  <div id="callback">
    <LoadingSpinner />
  </div>
</template>

<script>
import LoadingSpinner from "../components/LoadingSpinner";
import { apiClient } from "../services/api";
import { StorageKeys, getItem } from "@/services/storage";

export default {
  components: { LoadingSpinner },
  async mounted() {
    await this.save_token();
  },
  methods: {
    getParamsURLCallback() {
      var url = window.location.href;
      var params = Object.fromEntries(
        new URLSearchParams(url.split("?").pop())
      );
      return params;
    },
    async save_token() {
      try {
        const { code } = this.getParamsURLCallback();

        const response = await apiClient.patch('/youtube/save-token', {
          cod_producao: this.$store.state.producoes.selectedProducao?.cod_producao || getItem(StorageKeys.SELECTED_PRODUCTION),
          code
        })

        if(response.status === 200) {
          this.$toast.success("Fluxo OAuth concluído, token salvo com sucesso.")
          window.close()
        }

      } catch (error) {
        this.$toast.error('Não foi possível concluir o fluxo OAuth.')
        return window.close()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#callback {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
</style>
